import {
  IconColor,
  IconName,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { TransactionStateName as T } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/enums/transaction/transaction-state.enum';

interface GenericTransactionState {
  name: string;
  color: string;
  icon: { name: IconName; color: IconColor };
}

export const TransactionStateMap: Record<T, string> = {
  [T.TRANSACTION_STARTED]: 'TRANSACTION_STARTED',
  [T.TRANSACTION_STOPPED]: 'TRANSACTION_STOPPED',
  [T.TRANSACTION_EXPIRED]: 'TRANSACTION_EXPIRED',
  [T.REMOTE_START_TRANSACTION_REQUESTED]: 'REMOTE_START_TRANSACTION_REQUESTED',
  [T.REMOTE_STOP_TRANSACTION_REQUESTED]: 'REMOTE_STOP_TRANSACTION_REQUESTED',
  [T.REMOTE_START_TRANSACTION_ACCEPTED]: 'REMOTE_START_TRANSACTION_ACCEPTED',
  [T.REMOTE_STOP_TRANSACTION_ACCEPTED]: 'REMOTE_STOP_TRANSACTION_ACCEPTED',
  [T.REMOTE_START_TRANSACTION_REFUSED]: 'REMOTE_START_TRANSACTION_REFUSED',
  [T.REMOTE_STOP_TRANSACTION_REFUSED]: 'REMOTE_STOP_TRANSACTION_REFUSED',
};

export const TransactionStateEnum: Record<string, GenericTransactionState> = {
  TRANSACTION_STARTED: {
    name: 'TRANSACTION_STARTED',
    color: 'bg-surface-brand-secondary',
    icon: { name: 'lightning-02', color: IconColor.Secondary },
  },
  TRANSACTION_STOPPED: {
    name: 'TRANSACTION_STOPPED',
    color: 'bg-surface-success',
    icon: { name: 'check-circle', color: IconColor.Success },
  },
  TRANSACTION_EXPIRED: {
    name: 'TRANSACTION_EXPIRED',
    color: 'bg-surface-error',
    icon: {
      name: 'x-circle',
      color: IconColor.Error,
    },
  },
  REMOTE_START_TRANSACTION_REQUESTED: {
    name: 'REMOTE_START_TRANSACTION_REQUESTED',
    color: 'bg-surface-informations',
    icon: { name: 'clock', color: IconColor.Informations },
  },
  REMOTE_STOP_TRANSACTION_REQUESTED: {
    name: 'REMOTE_STOP_TRANSACTION_REQUESTED',
    color: 'bg-surface-informations',
    icon: { name: 'clock', color: IconColor.Informations },
  },
  REMOTE_START_TRANSACTION_ACCEPTED: {
    name: 'REMOTE_START_TRANSACTION_ACCEPTED',
    color: 'bg-surface-success',
    icon: { name: 'lightning-02', color: IconColor.Secondary },
  },
  REMOTE_STOP_TRANSACTION_ACCEPTED: {
    name: 'REMOTE_STOP_TRANSACTION_ACCEPTED',
    color: 'bg-surface-success',
    icon: { name: 'check-circle', color: IconColor.Success },
  },
  REMOTE_START_TRANSACTION_REFUSED: {
    name: 'REMOTE_START_TRANSACTION_REFUSED',
    color: 'bg-surface-error',
    icon: {
      name: 'x-circle',
      color: IconColor.Error,
    },
  },
  REMOTE_STOP_TRANSACTION_REFUSED: {
    name: 'REMOTE_STOP_TRANSACTION_REFUSED',
    color: 'bg-surface-error',
    icon: {
      name: 'x-circle',
      color: IconColor.Error,
    },
  },
};

export const mapStateToGenericTransactionState = (
  state: T,
): GenericTransactionState => {
  return (
    TransactionStateEnum[TransactionStateMap[state]] ?? {
      name: 'UNKNOWN',
      color: 'bg-surface-brand-secondary',
      icon: { name: 'x-close', color: IconColor.Secondary },
    }
  );
};
